import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Logger, { LOG_LEVELS } from '../../utils/logger';
import { ErrorWarningAction, ErrorKind, FilingTypeEnum, FeatureFlagEnum } from '../../utils/enums';

const log = new Logger('DISABLED_ACTIONS', LOG_LEVELS.DEBUG);

const IOSS_CORRECTION_FF = FeatureFlagEnum.ENABLE_IOSS_CORRECTION_ERRORS_WARNINGS;
const NonUnion_OSS_CORRECTION_FF_VIEW = FeatureFlagEnum.ENABLE_NON_UNION_OSS_CORRECTION_VIEW_ERRORS_WARNINGS;
const Union_OSS_CORRECTION_FF_VIEW_ERRORS_WARNINGS = FeatureFlagEnum.ENABLE_UNION_OSS_CORRECTION_VIEW_ERRORS_WARNINGS;
const VAT_RETURN_NON_CORRECTION_FF_VIEW_ERRORS_WARNINGS = FeatureFlagEnum.ENABLE_VAT_RETURN_NON_CORRECTION_VIEW_ERRORS_WARNINGS;
const VAT_Return_CORRECTION_VIEW_ERRORS_WARNINGS = FeatureFlagEnum.ENABLE_VAT_RETURN_CORRECTION_ERRORS_WARNINGS;
const VAT_Book_CORRECTION_VIEW_ERRORS_WARNINGS = FeatureFlagEnum.ENABLE_VAT_BOOK_CORRECTION_ERRORS_WARNINGS;
const EC_LISTING_CORRECTION_VIEW_ERRORS_WARNINGS = FeatureFlagEnum.ENABLE_EC_LISTING_CORRECTION_ERRORS_WARNINGS;

//actions related to Transactions for closed filing
const TRANSACTIONS_FOR_CLOSED_FILING_ERROR_ACTIONS=[
    ErrorWarningAction.REOPEN_AND_REDELIVER.value,
    ErrorWarningAction.RESCHEDULE_AS_NONCORRECTIVE.value,
    ErrorWarningAction.RESCHEDULE_AS_CORRECTIVE.value,
];

//Disable actions for Errors&Warnings Category/main page
const TRANSACTIONS_FOR_CLOSED_FILING_ERROR_DISABLE_ACTIONS = [
    ErrorWarningAction.ERROR_ACTION_MOVE_WARNING_TO_ERROR.value,
    ErrorWarningAction.ERROR_ACTION_SAVE_TO_FILE.value,
    ErrorWarningAction.EXPORT.value,
    ErrorWarningAction.RESCHEDULE_AS_CORRECTIVE.value,
    ErrorWarningAction.RESCHEDULE_AS_NONCORRECTIVE.value,
    ErrorWarningAction.ERROR_ACTION_ENTER_CREDIT_NOTE_CERTIFICATE_DATE.value,
];

const DEFAULT_ERROR_DISABLE_ACTIONS = [
    ...TRANSACTIONS_FOR_CLOSED_FILING_ERROR_ACTIONS,
    ErrorWarningAction.ERROR_ACTION_MOVE_WARNING_TO_ERROR.value,
    ErrorWarningAction.ERROR_ACTION_SAVE_TO_FILE.value,
    ErrorWarningAction.EXPORT.value,
    ErrorWarningAction.ERROR_ACTION_ENTER_CREDIT_NOTE_CERTIFICATE_DATE.value,
];

const DEFAULT_WARNING_DISABLE_ACTIONS = [
    ...TRANSACTIONS_FOR_CLOSED_FILING_ERROR_ACTIONS,
    ErrorWarningAction.ERROR_ACTION_SAVE_TO_FILE.value,
    ErrorWarningAction.BULK_FIND_AND_REPLACE.value,
    ErrorWarningAction.EXPORT.value,
    ErrorWarningAction.ERROR_ACTION_ENTER_CREDIT_NOTE_CERTIFICATE_DATE.value,
];

//Disabled actions for Errors&Warnings Subcategory page
const TRANSACTIONS_FOR_CLOSED_FILING_ERROR_SUBCATEGORY_DISABLE_ACTIONS = [
    ErrorWarningAction.ERROR_ACTION_MOVE_WARNING_TO_ERROR.value,
    ErrorWarningAction.ERROR_ACTION_ENTER_CREDIT_NOTE_CERTIFICATE_DATE.value,
];

const DEFAULT_ERROR_SUBCATEGORY_DISABLE_ACTIONS = [
    ...TRANSACTIONS_FOR_CLOSED_FILING_ERROR_ACTIONS,
    ErrorWarningAction.ERROR_ACTION_MOVE_WARNING_TO_ERROR.value,
    ErrorWarningAction.ERROR_ACTION_ENTER_CREDIT_NOTE_CERTIFICATE_DATE.value,
];

const DEFAULT_WARNING_SUBCATEGORY_DISABLE_ACTIONS = [
    ...TRANSACTIONS_FOR_CLOSED_FILING_ERROR_ACTIONS,
    ErrorWarningAction.ERROR_ACTION_SAVE_TO_FILE.value,
    ErrorWarningAction.BULK_FIND_AND_REPLACE.value,
    ErrorWarningAction.ERROR_ACTION_ENTER_CREDIT_NOTE_CERTIFICATE_DATE.value,
];

const ALL_ACTIONS = [
    ErrorWarningAction.REOPEN_AND_REDELIVER.value,
    ErrorWarningAction.RESCHEDULE_AS_CORRECTIVE.value,
    ErrorWarningAction.RESCHEDULE_AS_NONCORRECTIVE.value,
    ErrorWarningAction.ERROR_ACTION_ENTER_CREDIT_NOTE_CERTIFICATE_DATE.value,
    ErrorWarningAction.BULK_FIND_AND_REPLACE.value,
    ErrorWarningAction.EXPORT.value,
    ErrorWarningAction.ERROR_ACTION_VATRATE.value,
    ErrorWarningAction.ERROR_ACTION_INVNR.value,
    ErrorWarningAction.ERROR_ACTION_SUPINVNR.value,
    ErrorWarningAction.ERROR_ACTION_VATNR.value,
    ErrorWarningAction.ERROR_ACTION_OSS_VATNR.value,
    ErrorWarningAction.ERROR_ACTION_MOVE.value,
    ErrorWarningAction.ERROR_ACTION_DELETE.value,
    ErrorWarningAction.ERROR_ACTION_MOVE_WARNING_TO_ERROR.value,
    ErrorWarningAction.ERROR_ACTION_SAVE_TO_FILE.value,
];

const errorTransactionsForClosedFiling = 58;
const errorCreditNotesNotAllowed = 60;

export class DisabledActions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    //Get Disabled actions for Errors&Warnings Subcategories
    getDisabledActionsForSubcategories(subCategoryInfo){
        let isMultipleSelection = this.props.errorsSelection.size > 1;
        if(ErrorKind.ERROR == subCategoryInfo){
            if (this.props.errorCodeId === errorTransactionsForClosedFiling){
                let disabledOption;
                if (isMultipleSelection){
                    disabledOption = [...TRANSACTIONS_FOR_CLOSED_FILING_ERROR_SUBCATEGORY_DISABLE_ACTIONS,
                        ErrorWarningAction.ERROR_ACTION_SAVE_TO_FILE.value ,
                        ErrorWarningAction.RESCHEDULE_AS_CORRECTIVE.value,
                        ErrorWarningAction.RESCHEDULE_AS_NONCORRECTIVE.value
                    ]
                }
                else{
                    disabledOption = !this.props.filingTypeEnabledForRescheduleCorrection ?
                      [
                        ...TRANSACTIONS_FOR_CLOSED_FILING_ERROR_SUBCATEGORY_DISABLE_ACTIONS,
                        ErrorWarningAction.RESCHEDULE_AS_CORRECTIVE.value,
                        ErrorWarningAction.RESCHEDULE_AS_NONCORRECTIVE.value
                      ] :
                      TRANSACTIONS_FOR_CLOSED_FILING_ERROR_SUBCATEGORY_DISABLE_ACTIONS
                }
                return disabledOption ;
            }
            return isMultipleSelection ?
              [
                ...DEFAULT_ERROR_SUBCATEGORY_DISABLE_ACTIONS,
                ErrorWarningAction.ERROR_ACTION_SAVE_TO_FILE.value
              ] :
              DEFAULT_ERROR_SUBCATEGORY_DISABLE_ACTIONS;
        }
        return DEFAULT_WARNING_SUBCATEGORY_DISABLE_ACTIONS;
    }

    enableMultipleActions = (enabledActions) => _.reject(ALL_ACTIONS, option => enabledActions?.includes(option));

    //Get Disabled actions for Errors and warnings Categories
    getDisableActionsForCategories(){
        if (this.props.errorsSelection.size >= 1) {
            return this.props.errorCodeId === errorTransactionsForClosedFiling
                ? TRANSACTIONS_FOR_CLOSED_FILING_ERROR_DISABLE_ACTIONS
                : DEFAULT_ERROR_DISABLE_ACTIONS;
        }
        if (this.props.warningsSelection.size === 1) {
            return DEFAULT_WARNING_DISABLE_ACTIONS;
        }

        // More than one checked items in the list and not code 58
        return [...DEFAULT_ERROR_DISABLE_ACTIONS, ErrorWarningAction.ERROR_ACTION_SAVE_TO_FILE.value];
    }

    isIossCorrection = () => {
        switch (false) {
            case this.props.featureFlags?.[IOSS_CORRECTION_FF]:
            case this.props.errorCodeId === errorTransactionsForClosedFiling:
            case this.props.selectedFilingType === FilingTypeEnum.OSSIMPORT:
                return false;
            default:
                return true;
        }
    }

    isOssNonUnionCorrection = () => {
        switch(false) {
            case this.props.featureFlags?.[NonUnion_OSS_CORRECTION_FF_VIEW] === true:
            case this.props.errorCodeId === errorTransactionsForClosedFiling:
            case this.props.selectedFilingType === FilingTypeEnum.OSSNONUNION:
                return false;
            default:
                return true;
        }
    }

    isOssUnionCorrection = () => {
        switch(false) {
            case this.props.featureFlags?.[Union_OSS_CORRECTION_FF_VIEW_ERRORS_WARNINGS] === true:
            case this.props.errorCodeId === errorTransactionsForClosedFiling:
            case this.props.selectedFilingType === FilingTypeEnum.OSSUNION:
                return false;
            default:
                return true;
        }
    }

    isVATReturnCorrection = () => {
        switch(false) {
            case this.props.featureFlags?.[VAT_Return_CORRECTION_VIEW_ERRORS_WARNINGS] === true:
            case this.props.errorCodeId === errorTransactionsForClosedFiling:
            case this.props.selectedFilingType === FilingTypeEnum.VATRETURN:
                return false;
            default:
                return true;
        }
    }

    isEcListingCorrection = () => {
        switch(false) {
            case this.props.featureFlags?.[EC_LISTING_CORRECTION_VIEW_ERRORS_WARNINGS] === true:
            case this.props.errorCodeId === errorTransactionsForClosedFiling:
            case this.props.selectedFilingType === FilingTypeEnum.ECLISTING:
                return false;
            default:
                return true;
        }
    }

    isVATReturnSingleClosedFiling = () => {
        return _.every([
          this.props.errorCodeId === errorTransactionsForClosedFiling,
          this.props.selectedFilingType === FilingTypeEnum.VATRETURN,
          this.props.errorsSelection.size === 1
        ]);
    }

    isVATReturnNonCorrection = () => {
        switch(false) {
            case this.props.featureFlags?.[VAT_RETURN_NON_CORRECTION_FF_VIEW_ERRORS_WARNINGS] === true:
            case this.props.errorCodeId === errorTransactionsForClosedFiling:
            case this.props.selectedFilingType === FilingTypeEnum.VATRETURN:
                return false;
            default:
                return true;
        }
    }

    isVATBookCorrection = () => {
        switch(false) {
            case this.props.featureFlags?.[VAT_Book_CORRECTION_VIEW_ERRORS_WARNINGS] === true:
            case this.props.errorCodeId === errorTransactionsForClosedFiling:
            case this.props.selectedFilingType === FilingTypeEnum.VATBOOKS:
                return false;
            default:
                return true;
        }
    }

    getEnabledActions() {
        const actions = [];

        if (this.props.errorCodeId === errorCreditNotesNotAllowed) {
            actions.push(ErrorWarningAction.ERROR_ACTION_ENTER_CREDIT_NOTE_CERTIFICATE_DATE.value);
        }

        // enable rescheduling as corrective if this is a closed period error plus either:
        // - the relevant feature flag is set for the return type, __OR__
        // - the return type is VAT Return and exactly one error is selected (this is regardless of any Feature Flags)
        if (_.some(
          [
            this.isIossCorrection.bind(this),
            this.isOssNonUnionCorrection.bind(this),
            this.isOssUnionCorrection.bind(this),
            this.isVATReturnCorrection.bind(this),
            this.isVATBookCorrection.bind(this),
            this.isVATReturnSingleClosedFiling.bind(this),
            this.isEcListingCorrection.bind(this)
          ],
          check => check()
        )) {
            actions.push(ErrorWarningAction.RESCHEDULE_AS_CORRECTIVE.value);
        }

        // enable rescheduling as a non-corrective if this is a closed period error, the return type is VAT Return, plus either:
        // - the feature flag is enabled, __OR__
        // - exactly one error is selected (regardless of any Feature Flags)
        if (_.some(
          [
            this.isVATReturnNonCorrection.bind(this),
            this.isVATReturnSingleClosedFiling.bind(this)
          ],
          check => check()
        )) {
            actions.push(ErrorWarningAction.RESCHEDULE_AS_NONCORRECTIVE.value);
        }

        return actions;
    }

    //Get Disabled actions for Errors and warnings
    getDisableActions(subCategoryInfo) {
        if (subCategoryInfo && (this.props.errorsSelection.size >= 1 || this.props.warningsSelection.size >= 1))
        {
            const enabledActions = this.getEnabledActions();

            if (enabledActions.length > 0) {
                return this.enableMultipleActions(enabledActions);
            } else {
                return this.getDisabledActionsForSubcategories(subCategoryInfo);
            }
        }

        let disabledActions = this.getDisableActionsForCategories();

        // loop through 'is<returnType>Correction' functions, short-circuiting if one returns true
        const isAllowableCorrection = _.some(
          [
            this.isIossCorrection.bind(this),
            this.isOssNonUnionCorrection.bind(this),
            this.isOssUnionCorrection.bind(this),
            this.isVATReturnCorrection.bind(this),
            this.isVATBookCorrection.bind(this),
            this.isEcListingCorrection.bind(this)
          ],
          check => check()
        );

        if (isAllowableCorrection && this.props.totalItemsCount === 1) {
            // re-enable Reschedule As Corrective for single Period Closed error on landing page, for allowed return types
            disabledActions = _.reject(
              disabledActions,
              (option) => option === ErrorWarningAction.RESCHEDULE_AS_CORRECTIVE.value
            );
        }
        if(this.isVATReturnNonCorrection() && this.props.totalItemsCount === 1) {
            disabledActions = _.reject(
                disabledActions,
                (option) => option === ErrorWarningAction.RESCHEDULE_AS_NONCORRECTIVE.value
              );
        }
        return disabledActions;
    }

    render() {
        const actionsForSelection = this.getDisableActions(this.props.subCategoryInfo);
        this.props.disabledActionsChanged(actionsForSelection);

        return (<></>);
    }
}

function mapStateToProps(state) {
    // Required
    return {
        featureFlags: state.featureFlag && state.featureFlag.data
    };
}


export default connect(mapStateToProps)(DisabledActions);
